import React, { useEffect, useState } from "react";
import { useUser } from "util/UserContext";
import ActorsList from "./ActorsList";
import ScrollHideContainer from "ui/ScrollHideContainer";
import ScrollableTabsList from "ui/ScrollableTabsList";
import { setDocumentTitle } from "util/pageTitles";
import { capitalizeFirstLetter } from "util/textUtils";
import { useParams } from "react-router-dom";
import TeamsList from "components/Teams/TeamsList";
import MeetingsList from "components/Meetings/MeetingsList";
/**
 * TeamsTabs component that handles displaying tabs for Teams/Parteas
 * Shows "All Parteas" by default, and "My Parteas" tab for logged-in users
 */
const Community: React.FC = () => {
  const { currentUser } = useUser();
  const { tab } = useParams<{ tab?: string }>();
  const [selectedTab, setSelectedTab] = useState<string>("everyone");

  setDocumentTitle(`Communitea - ${capitalizeFirstLetter(selectedTab)}`);

  useEffect(() => {
    if (tab) {
      setSelectedTab(tab);
    } else {
      setSelectedTab('everyone');
    }
  }, [tab]);

  // Build tabs data based on user authentication status
  const tabsData = [
    {
      label: "Everyone",
      value: "everyone",
      route: `/communitea/everyone`,
    },
    {
      label: "Events",
      value: "events",
      route: `/communitea/events`,
    },
    {
      label: "People",
      value: "people",
      route: `/communitea/people`,
    },
    {
      label: "Parteas",
      value: "parteas",
      route: `/communitea/parteas`,
    }
  ];
  // Add "My Parteas" tab only if user is logged in
  if (currentUser) {
    tabsData.push({
      label: "My parteas",
      value: "member",
      route: `/communitea/parteas/member`,
    });
  }

  // Handle tab change
  const handleTabChange = (newTab: string) => {
    setSelectedTab(newTab);
  };


  return (
    <div className="py-0 relative">
      <ScrollHideContainer 
        className="z-50 max-w-5xl bg-eoe-bg dark:bg-eoe-dark-bg"
        hideOffset={57}
        threshold={56}
      >
        <div className="p-2">
          <ScrollableTabsList
            key="communitea-tabs"
            pageTitle="Everyone"
            tabs={tabsData}
            selectedTab={selectedTab}
            onTabChange={handleTabChange}
          />
        </div>
      </ScrollHideContainer>

      {/* Tabs Content */}
      <div className="py-2 px-2 md:px-4 relative">
        {selectedTab === "everyone" && (
          <ActorsList 
            isLoading={() => {}} 
            actorTypes={["user", "team"]} 
          />
        )}
        {selectedTab === "events" && (
          <MeetingsList initialSort="soonest" />
        )}
        {selectedTab === "people" && (
          <ActorsList 
            isLoading={() => {}} 
            actorTypes={["user"]} 
          />
        )}
        {selectedTab === "parteas" && (
          <TeamsList 
            isLoading={() => {}} 
            onlyMemberTeams={false} 
          />
        )}
        {selectedTab === "member" && currentUser && (
          <TeamsList 
            isLoading={() => {}} 
            onlyMemberTeams={true} 
          />
        )}
      </div>
    </div>
  );
};

export default Community;
